import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Rightarrow from "../assets/icons/Rightarrow";
import Lock from "../assets/icons/Lock";
import Location from "../assets/icons/Location";

import Modal from "../components/Modal";
import stepImg from "../assets/images/stepimg.png";
import checked from "../assets/images/right.png";
import GoogleAutocomplete from "react-google-autocomplete";
import PlaceSearch from "../components/PlaceSearch";
import { get, post, postWithImage } from "../network/api";
import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import PaymentForm from "../../src/components/PaymentModal";
import PaymentFormSubscription from "../../src/components/PaymentModalSubscription";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // Smooth scrolling
  });
};




const validationSchema = Yup.object({
  // pvdNumber: Yup.string().required("PVD Number is required"),
  companyName: Yup.string().required("Company Name is required"),
  registrationNumber: Yup.string().required("Registration Number is required"),
  companyAddress: Yup.string().required("Company Address is required"),
  restaurantName: Yup.string().required("Restaurant Name is required"),
  // idNumber: Yup.string().required("ID Number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  // address: Yup.string().required("Restaurant Owner House Address is required"),
  phoneNumber: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(8, "Must be at least 8 digits")
    .max(8, "Must be at most 8 digits")
    .required("Phone Number is required"),
});

const AddRestaurantForm = () => {
  const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language; // e.g. "en", "lv"


  let tabs = [
    {
      title: t("restaurant_information"),
      icon: "1",
      content: t("restaurant_information_details"),
    },
    {
      title: t("select_price_plans"),
      icon: "2",
      content: t("select_price_plans_details"),
    },
  ];
  const center = { lat: 40.7128, lng: -74.006 }; // Default location (New York City)

  const [activeTab, setActiveTab] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [formData, setFormData] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCpQmelShKu78ugZ2iNfjGOZlUqHt950SI", // Replace with your API key
  });
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [mapCenter, setMapCenter] = useState(center);

  const mapRef = useRef(null);
  const placeSearchRef = useRef();

  const handleMapLoad = (map) => {
    mapRef.current = map; // Save the map instance for later use
  };

  const handleMapIdle = () => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter(); // Get the new center
      console.log({ lat: newCenter.lat(), lng: newCenter.lng() });
      setMapCenter({ lat: newCenter.lat(), lng: newCenter.lng() });
      if (placeSearchRef.current) {
        placeSearchRef.current.updateField(newCenter.lat(), newCenter.lng());
      }
    }
  };
  const handleContinue = (values) => {
    if (activeTab==0) { 
      setFormData(values)
    }
    if (activeTab < tabs.length - 1) {
      setActiveTab(activeTab + 1);
      scrollToTop();
    }
  };

  const handleBack = () => {
    if (activeTab > 0) {
      setActiveTab(activeTab - 1);
    }
  };
  const handlePlaceSelect = (place) => {
    console.log("Selected Place:", place);
    setMapCenter({
      lat: place.geometry.location.lat,
      lng: place.geometry.location.lng,
    });
  };
  
  const handleViewPlan = (plan) => {
    setSelectedPlan(plan);
    setIsModalOpen(true);
  };
  useEffect(() => {
    getPlans();
  }, []);
  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
    // setIsLoading(false);
  };

  async function createRestaurant() {
    try {
      console.log("Values are ", selectedPlan,formData);
      setShowPaymentModal(true);
      // make ther payment
    } catch (e) {}
  }
  async function handlePaymentSuccess(data){
    console.log(data, "Payment Success")
    handleClosePaymentModal(false)
    toast.success("Please wait", {
      position: "bottom-center",
      autoClose: 3000,
    });
    try{
      const response = await post('customer/create-restaurants', {
        "email": formData.email,
        "full_name": "OWNER",
        "identification_number": formData?.idNumber,
        "owner_address_latitude": 0,
        "owner_address_longitude": 0,
        "owner_address": formData?.owner_address,
        "owner_place_id": "-",
        "restaurant_address_latitude": selectedPlace?.lat,
        "restaurant_address_longitude": selectedPlace?.lng,
        "restaurant_address": selectedPlace?.address,
        "restaurant_place_id": selectedPlace?.place_id,
        "company_pvd_number": formData?.pvdNumber,
        "company_name": formData?.companyName,
        "company_registration_number": formData?.registrationNumber,
        "company_address_latitude": 0,
        "company_address_longitude": 0,
        "company_address": formData?.companyAddress,
        "company_place_id": "-",
        "stripe_payment_method_id": data?.payment_method,
        "restaurant_name":formData?.restaurantName,
        "gst_number": formData?.gst_number,
        "company_vat_number": formData?.vatNumber,
        "subscription_id": selectedPlan._id
    })
    toast.success("Restaurant created successfully!", {
      position: "bottom-center",
      autoClose: 3000,
    });
    setTimeout(() => {
  window.location.href = process.env.REACT_APP_RESTAURANT_FRONTEND_URL;
}, 3000);

    }
    catch(e){
      toast.error(e.message, {
        position: "bottom-center",
        autoClose: 3000,
      });
    }
    
  }
  async function handlePaymentError(data){
    console.log(data, "Payment Error")
    handleClosePaymentModal(false)
  }
  async function getPlans() {
    try {
      const data = await get("customer/get-subscription");
      setListings(data);
      setLoading(false);
    } catch (e) {
      // setError(error.message); // Handle any errors
      setLoading(false);
    }
  }
  if (!isLoaded) return <div>Loading...</div>;
  return (
    <div>
      <ToastContainer />
      <section className="add_rest_for">
      <div className="wrapper">
        <Formik
          initialValues={{
            pvdNumber: "",
            companyName: "",
            registrationNumber: "",
            companyAddress: "",
            restaurantName: "",
            idNumber: "",
            email: "",
            address: "",
            phoneNumber: "",
            location: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log("Form Data:", values);
            handleContinue(values); // proceed to next tab or submit
          }}
        >
          {({ handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <div className="overflow_auto">
                <div className="stepper">
                  {tabs.map((tab, index) => (
                    <div
                      key={index}
                      className={`step ${
                        index < activeTab ? "completed" : ""
                      } ${index === activeTab ? "active" : ""}`}
                    >
                      <div className="step-icon">
                        {index < activeTab ? (
                          <img
                            className="checked"
                            src={checked}
                            alt="Checked"
                          />
                        ) : (
                          <img src={stepImg} alt={tab.title} />
                        )}
                      </div>
                      <div className="step-title">
                        <p className="tb_head">{tab.title}</p>
                        <p className="tb_para">{tab.content}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="tab-content">
                {activeTab === 0 && (
                  <div className="tab-panel">
                    <div className="form_grids">
                      <div className="card crd_6">
                        <h3 className="card_title">{t("company_details")}</h3>
                        <div className="input_frm_grid">
                          <div className="form_group">
                            <label htmlFor="pvdNumber">{t("pvd_number")}</label>
                            <Field
                              type="text"
                              name="pvdNumber"
                              placeholder={t("enter_your_pvd_number_here")}
                            />
                            <ErrorMessage
                              name="pvdNumber"
                              component="div"
                              className="error"
                            />
                          </div>
                            <div className="form_group">
                            <label htmlFor="vatNumber">{t("vat_number")}</label>
                            <Field
                              type="text"
                              name="vatNumber"
                              placeholder={t("enter_your_vat_number_here")}
                            />
                            <ErrorMessage
                              name="vatNumber"
                              component="div"
                              className="error"
                            />
                          </div>
                          <div className="form_group">
                            <label htmlFor="companyName">{t("company_name")}</label>
                            <Field
                              type="text"
                              name="companyName"
                              placeholder={t("enter_your_company_name_here")}
                            />
                            <ErrorMessage
                              name="companyName"
                              component="div"
                              className="error"
                            />
                          </div>
                          <div className="form_group">
                            <label htmlFor="registrationNumber">
                            {t("registration_number")}
                            </label>
                            <Field
                              type="text"
                              name="registrationNumber"
                              placeholder={t("enter_your_registration_number_here")}
                            />
                            <ErrorMessage
                              name="registrationNumber"
                              component="div"
                              className="error"
                            />
                          </div>
                          <div className="form_group">
                            <label htmlFor="companyAddress">
                            {t("company_address")}
                            </label>
                            <Field
                              type="text"
                              name="companyAddress"
                              placeholder= {t("enter_your_company_address_here")}
                            />
                            <ErrorMessage
                              name="companyAddress"
                              component="div"
                              className="error"
                            />
                          </div>
                          <div className="form_group">
                            <label htmlFor="restaurantName">
                            {t("restaurant_name")}
                            </label>
                            <Field
                              type="text"
                              name="restaurantName"
                              placeholder= {t("enter_your_restaurant_name_here")}
                            />
                            <ErrorMessage
                              name="restaurantName"
                              component="div"
                              className="error"
                            />
                          </div>
                          
                          
                        </div>
                      </div>

                      <div className="card crd_6">
                        <div className="lcn_title">
                          <h3 className="card_title">{t("location_details")}</h3>
                          <p className="card_para">
                          {t("this_will_help_your_customers_and_delivery_riders_to_locate_your_store")}
                          </p>
                        </div>

                        <p className="ltc_title">
                        {t("please_place_the_pin_accurately_at_your_outlets_location_on_the_map")}
                        </p>

                        <PlaceSearch
                          onPlaceSelect={handlePlaceSelect}
                          getPlaceData={(data)=>setSelectedPlace(data)}
                          ref={placeSearchRef}
                        />

                        <div
                          className="map_wrapper"
                          style={{
                            borderRadius: "6px",
                            width: "100%",
                            overflow: "hidden",
                          }}
                        >
                          <GoogleMap
                            center={mapCenter}
                            zoom={14}
                            mapContainerStyle={{
                              width: "100%",
                              height: "100%",
                            }}
                            onLoad={handleMapLoad} // Capture the map instance
                            onDragEnd={() => handleMapIdle()}
                          >
                            {/* Marker at the center */}
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                fontSize: "30px",
                                color: "red",
                              }}
                            >
                              📍
                            </div>
                          </GoogleMap>
                          <div
                            style={{
                              padding: "10px",
                              background: "#fff",
                              textAlign: "center",
                              visibility: "hidden",
                            }}
                          >
                            <p>Selected Location:</p>
                            <p>
                              Latitude: {mapCenter.lat.toFixed(6)}, Longitude:{" "}
                              {mapCenter.lng.toFixed(6)}
                            </p>
                          </div>
                        </div>

                        {/* <div className="location_input">
                          <GoogleAutocomplete
                            apiKey="AIzaSyCpQmelShKu78ugZ2iNfjGOZlUqHt950SI"
                            onPlaceSelected={(place) => {
                              const latitude = place.geometry.location.lat();
                              const longitude = place.geometry.location.lng();
                              console.log("Latitude:", latitude);
                              console.log("Longitude:", longitude);
                            }}
                            className="location_search"
                            placeholder="Enter your restaurant location"
                          />

                          <div className="detect_btn">
                            <Location /> Detect
                          </div>
                        </div>

                        <div className="map_wrapper">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d310918.67109959055!2d-2.4544476606079773!3d52.49629615528557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4870942d1b417173%3A0xca81fef0aeee7998!2sBirmingham%2C%20UK!5e0!3m2!1sen!2sin!4v1728039654546!5m2!1sen!2sin"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Restaurant Location Map"
                          ></iframe>
                        </div> */}
                      </div>

                      <div className="card crd_full">
                        <h3 className="card_title">{t("restaurant_owner_details")}</h3>
                        <div className="input_frm_grid">
                          {/* <div className="form_group">
                            <label htmlFor="idNumber">{t("id_number")}</label>
                            <Field
                              type="text"
                              name="idNumber"
                              placeholder={t("enter_your_id_number_here")}
                            />
                            <ErrorMessage
                              name="idNumber"
                              component="div"
                              className="error"
                            />
                          </div> */}
                          <div className="form_group">
                            <label htmlFor="email">{t("email")}</label>
                            <Field
                              type="text"
                              name="email"
                              placeholder={t("enter_your_email_here")}
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="error"
                            />
                          </div>
                          {/* <div className="form_group">
                            <label htmlFor="address">
                            {t("restaurant_owner_house_address")}
                            </label>
                            <Field
                              type="text"
                              name="address"
                              placeholder={t("enter_your_restaurant_owner_house_address_here")}
                            />
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="error"
                            />
                          </div> */}
                          <div className="form_group">
                            <label htmlFor="phoneNumber">{t("phone_number")}</label>
                            <Field
                              type="number"
                              name="phoneNumber"
                              placeholder={t("enter_your_phone_number_here")}
                            />
                            <ErrorMessage
                              name="phoneNumber"
                              component="div"
                              className="error"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 1 && (
                  <div className="tab-panel">
                    <div className="pricing_flex">
                      {listings.map((plan, index) => (
                        <div key={plan.id} className="pricing_card">
                          <div className="pricing_card_number">{index + 1}</div>
                          <h3 className="pricing_name">{plan.name}</h3>
                          <p className="crd_price">{plan.price}€ per Month</p>
                          <div
                            className="view_all_flex"
                            onClick={() => {
  if (plan.status !== "locked") {
    handleViewPlan(plan);
  }
}}
                          >

                            {t('view_plan')} {plan.status === "locked" ? <Lock /> : <Rightarrow />}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="tab-footer">
                {activeTab > 0 && (
                  <button
                    type="button"
                    className="btn back-btn"
                    onClick={handleBack}
                  >
                    <Rightarrow /> {t("back")}
                  </button>
                )}
                <button type="submit" className="btn btn-primary">
                  {activeTab === tabs.length - 1 ? (
                    t("submit")
                  ) : (
                    <>
                      {t("continue")} <Rightarrow />
                    </>
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {/* Modal component goes here */}
      <Modal
        show={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
        size="md"
      >
        <div className="flex_md_modal">
          <div>
            <h2 className="subtitle_common">{selectedPlan?.name}</h2>
            <p>{selectedPlan?.price}€ per Month</p>
          </div>
          <button
            className="btn btn-secondary"
            onClick={() => createRestaurant()}
          >
            Buy Plan <Rightarrow />
          </button>
        </div>
        <ul className="launch_list">
          <li>
  {currentLanguage === "en"
    ? `Includes ${selectedPlan?.free_orders} order per month, additional orders are at ${selectedPlan?.extra_price_per_order} per order`
    : `Ietver ${selectedPlan?.free_orders} pasūtījumu mēnesī, papildu pasūtījumi maksā ${selectedPlan?.extra_price_per_order} par pasūtījumu`}
</li>

          {(currentLanguage === "en"
    ? selectedPlan?.offers
    : selectedPlan?.offers_lv
  )?.map((offer, index) => (
    <li key={index}>{offer}</li>
  ))}

          
        </ul>
      </Modal>
      <Modal show={showPaymentModal} onClose={handleClosePaymentModal}
      
      >
        
        <PaymentFormSubscription
          price={selectedPlan?.stripe_price_id}
          name = {formData?.restaurantName}
          email =  {formData?.email}
          handleErrorCallback={ handlePaymentError}
          handleSuccessCallback={handlePaymentSuccess}
        ></PaymentFormSubscription>
      </Modal>
    </section>
    </div>
    
  );
};

export default AddRestaurantForm;
